import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as policy from '../policy'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: policy.RESOURCE.payload.dimension.partialId,
      partialId: policy.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Names of other policies that this policy references or that commonly apply to the same questions.',
    isOptional: true,
    name: 'Related Policies',
    partialId: PartialId.Standard.create('related_policies'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
